import { FC, useState, useRef } from 'react'
import 'katex/dist/katex.min.css'
import Latex from 'react-latex-next'
import useWindowDimensions from '../hooks/useWindowDimensions'

type TooltipProps = {
  contentLatex?: string
  title?: string
  enabled: boolean
}

const TOOLTIP_WIDTH = 170

const getTooltipPosition = (rect: DOMRect, windownWidth: number) => {
  return {
    top: rect.top - 105,
    left: Math.min(
      Math.max(rect.left - TOOLTIP_WIDTH / 2 + rect.width / 2, 0),
      windownWidth - TOOLTIP_WIDTH
    ), // Make sure doesn't cut from left or right
    width: TOOLTIP_WIDTH,
  }
}
export const LatexTooltip: FC<TooltipProps> = ({
  children,
  contentLatex,
  title,
  enabled,
}) => {
  const [open, setOpen] = useState(false)
  const { width } = useWindowDimensions()

  const handleHover = () => setOpen(true)
  const handleLeave = () => setOpen(false)
  let content = `$${contentLatex}$`

  const inputRef = useRef<HTMLDivElement>(null)

  const rect = inputRef?.current?.getBoundingClientRect()

  let generatedStyle = {}
  if (rect) {
    generatedStyle = getTooltipPosition(rect, width)
  }

  const tooltip =
    enabled && open ? (
      <div
        className="fixed h-24 border bg-white opacity-70 tooltip p-1 flex flex-col justify-items-stretch items-center rounded-lg"
        style={generatedStyle}
      >
        <div className="font-bold">{title}</div>
        <Latex>{content}</Latex>
      </div>
    ) : undefined
  return (
    <div ref={inputRef}>
      <div onMouseEnter={handleHover} onMouseLeave={handleLeave}>
        {children}
      </div>
      {tooltip}
    </div>
  )
}
